module.exports = __webpack_public_path__ + "static/media/screen-1.bd090bf9.webp";